import { Divider } from '@mui/material'

import { Stack } from '@collaborate-health/uikit'
import { useSelector } from '@tabeeb/store'

import CompleteReviewButton from '@tabeeb/modules/forms/components/CompleteReviewButton'
import SendReviewFeedbackButton from '@tabeeb/modules/forms/components/SendReviewFeedbackButton'
import { getFormButtonsGroups, getIsSignFormButtonVisible } from '@tabeeb/modules/forms/selectors'
import { FormButtonsGroup } from '@tabeeb/modules/forms/services/enums'

import Signature from '../Signature'

const FormsButtons: React.FC = () => {
  const groups = useSelector(getFormButtonsGroups)
  const isCommon = groups.some((g) => g === FormButtonsGroup.Common)
  const isReview = groups.some((g) => g === FormButtonsGroup.Review)
  const isMergeReview = groups.some((g) => g === FormButtonsGroup.MergeReview)
  const isSignatureEnabled = useSelector(getIsSignFormButtonVisible)

  return (
    <>
      {isCommon && isSignatureEnabled && (
        <>
          <Stack paddingInline={1.5}>
            <Signature />
          </Stack>

          <Divider />
        </>
      )}

      {(isReview || isMergeReview) && (
        <>
          <Stack direction='row' justifyContent='space-evenly' spacing={1} paddingInline={1.5}>
            <CompleteReviewButton />
            <SendReviewFeedbackButton />
          </Stack>

          <Divider />
        </>
      )}
    </>
  )
}

export default FormsButtons

